import { LOCAL_STORAGE_KEYS } from 'utils/constants/localStorageKeys';
import { isSuperUser } from 'modules/user/superUser';
import LANGUAGE from './constants/language';

const SUPPORTED_LANGUAGES = Object.keys(LANGUAGE);

export const getFallbackLng = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const langFromQueryParam = urlParams.get('lang');

  const alreadySetLang = langFromQueryParam || localStorage.getItem(LOCAL_STORAGE_KEYS.LANGUAGE);

  if (isSuperUser() || !alreadySetLang || !SUPPORTED_LANGUAGES.includes(alreadySetLang)) {
    return LANGUAGE.en.SHORT;
  }

  return alreadySetLang;
};
